export default [
  // Organizer sidebar
  {
    condition: (user) => user?.role === 'organizer',
    icon: { name: 'fluent:calendar-16-regular' },
    name: 'My reservations',
    role: 'organizer',
    to: { name: 'portal-bookings' },
  },
  {
    condition: (user) => user?.role === 'organizer',
    icon: { name: 'tabler:file-invoice' },
    name: 'My invoices',
    role: 'organizer',
    to: { name: 'portal-invoices' },
  },
  {
    condition: (user) => user?.role === 'organizer',
    icon: { name: 'fluent:people-16-regular' },
    name: 'My users',
    role: 'organizer',
    to: { name: 'portal-users' },
  },
  // Main sidebar
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    icon: { name: 'fluent:calendar-checkmark-16-regular' },
    name: 'Agenda',
    role: 'admin',
    to: { name: 'portal-planner' },
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    icon: { name: 'fluent:calendar-16-regular' },
    key: 'overview',
    name: 'Overzicht',
    role: 'admin',
    to: { name: 'portal-bookings' },
  },
  {
    icon: { name: 'tabler:file-invoice' },
    key: 'invoices',
    name: 'Facturen',
    role: 'admin',
    to: { name: 'portal-invoices' },
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    activePath: { name: 'portal-damages' },
    children: [
      {
        icon: { name: 'fluent:wrench-16-regular' },
        name: 'Schade',
        to: { name: 'portal-damages' },
      },
      {
        icon: { name: 'lucide:angry' },
        name: 'Opmerkingen',
        to: { name: 'portal-complaints' },
      },
      {
        icon: { name: 'fluent:settings-16-regular' },
        name: 'Schade-types',
        to: { name: 'portal-damage' },
      },
      {
        icon: { name: 'fluent:settings-16-regular' },
        name: 'Klacht-types',
        role: 'employee',
        to: { name: 'portal-complainttypes' },
      },
      // {
      //   component: {
      //     name: 'SidebarHeader',
      //     props: {
      //       text: 'Instellingen',
      //     },
      //   },
      //   name: 'divider-instellingen',
      // },
    ],
    icon: { name: 'fluent:alert-16-regular' },
    name: 'Meldingen',
    role: 'admin',
  },
  // {
  //   children: [
  //     {
  //       icon: { name: 'tabler:file-invoice' },
  //       key: 'overview',
  //       name: 'Overzicht',
  //       role: 'organizer',
  //       to: { name: 'portal-invoices' },
  //     },
  //   ],
  //   icon: { name: 'tabler:file-invoice' },
  //   key: 'invoices',

  //   name: 'Facturen',
  //   role: 'admin',
  // },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    activePath: { name: 'portal-packages' },
    children: [
      {
        icon: { name: 'fluent:box-16-regular' },
        name: 'Paketten',
        role: 'admin',
        to: { name: 'portal-packages' },
      },
      // {
      //   icon: { name: 'material-symbols:map-outline' },
      //   name: 'Transport kosten',
      //   role: 'admin',
      //   to: { name: 'portal-transport' },
      // },
      {
        icon: { name: 'material-symbols:map-outline' },
        name: 'Postcodes',
        role: 'admin',
        to: { name: 'portal-postal' },
      },
      {
        icon: { name: 'lucide:euro' },
        name: 'Prijzen',
        role: 'admin',
        to: { name: 'portal-packages-pricing' },
      },
      {
        icon: { name: 'tdesign:ticket' },
        name: 'Kortingsbonnen',
        role: 'admin',
        to: { name: 'portal-coupons' },
      },
    ],
    icon: { name: 'fluent:box-16-regular' },
    name: 'Prijzen',
    role: 'admin',
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    children: [
      {
        icon: { name: 'clarity:trailer-solid' },
        name: 'Aanhangwagens',
        role: 'admin',
        to: { name: 'portal-trailers' },
      },
      {
        icon: { name: 'fluent:vehicle-bicycle-16-regular' },
        name: 'Feestfietsen',
        role: 'admin',
        to: { name: 'portal-partybikes' },
      },
      {
        icon: { name: 'material-symbols-light:auto-towing-rounded' },
        name: 'Takelwagens',
        role: 'admin',
        to: { name: 'portal-towtrucks' },
      },
      {
        icon: { name: 'mingcute:route-line' },
        name: 'Tankbeurten',
        role: 'admin',
        to: { name: 'portal-rides' },
      },
    ],
    icon: { name: 'fluent:vehicle-car-16-regular' },
    name: 'Voertuigen',
    role: 'admin',
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    children: [
      {
        icon: { name: 'fluent:slide-text-person-16-regular' },
        name: 'Overzicht',
        role: 'admin',
        to: { name: 'portal-employees' },
      },
      {
        icon: { name: 'fluent:calendar-clock-16-regular' },
        name: 'Beschikbaarheden',
        to: { name: 'portal-availabilities', query: { sort: '-date_created' } },
      },
    ],
    icon: { name: 'fluent:slide-text-person-16-regular' },
    name: 'Werknemers',
    role: 'admin',
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    children: [
      {
        icon: { name: 'fluent:building-16-regular' },
        name: 'Overzicht',
        role: 'admin',
        to: { name: 'portal-agencies' },
      },

      {
        icon: { name: 'fluent:people-16-regular' },
        key: 'users',
        name: 'Gebruikers',
        role: 'admin',
        to: { name: 'portal-users' },
      },
    ],
    icon: { name: 'fluent:building-16-regular' },
    key: 'booking_agencies',
    name: 'Boekingskantoren',
    role: 'admin',
  },
  {
    condition: (user) => !user?.email.startsWith('mama@'),
    children: [
      {
        icon: { name: 'fluent:text-bullet-list-16-regular' },
        name: 'Home',
        to: { name: 'portal-cms-features' },
      },
      {
        icon: { name: 'fluent:document-one-page-16-regular' },
        name: 'Over ons',
        to: { name: 'portal-cms-about' },
      },
      {
        icon: { name: 'fluent:document-one-page-16-regular' },
        name: 'Prijzen',
        to: { name: 'portal-cms-prices' },
      },
      {
        icon: { name: 'fluent:question-circle-16-regular' },
        name: 'FAQ',
        to: { name: 'portal-cms-faq' },
      },
      {
        icon: { name: 'fluent:person-feedback-16-regular' },
        name: 'Testimonials',
        to: { name: 'portal-cms-testimonials' },
      },
      {
        icon: { name: 'lucide:bar-chart-4' },
        name: 'Statistieken',
        role: 'admin',
        to: { name: 'portal-statistics' },
      },
    ],
    icon: { name: 'fluent:document-edit-16-regular' },
    name: 'Inhoud',
    role: 'admin',
  },
  {
    children: [
      {
        icon: { name: 'material-symbols:calendar-month' },
        name: 'Mijn kalender',

        to: { name: 'portal-mycalendar-planning' },
      },
      {
        icon: { name: 'material-symbols:calendar-month' },
        name: 'Mijn beschikbaarheden',

        to: { name: 'portal-mycalendar-absences' },
      },
      {
        icon: { name: 'fluent:wrench-16-regular' },
        name: 'Schade melden',
        to: { name: 'portal-damages-new' },
      },
      {
        icon: { name: 'mingcute:route-line' },
        name: 'Tanken',
        to: { name: 'portal-rides' },
      },
      {
        icon: { name: 'fluent:settings-16-regular' },
        name: 'Facturatiegegevens',
        role: 'admin',
        to: { name: 'portal-cms-invoices' },
      },
    ],
    condition: (user) =>
      user?.role !== 'organizer' && !user?.email.startsWith('mama@'),
    icon: { name: 'fluent:slide-text-person-16-regular' },
    name: 'Mijn profiel',
    role: 'employee',
  },
]
